const specificProviders = [
    'yahoo',
    'icloud',
    'google',
    'outlook',
    'windowslive',
    'aol',
    'gmx',
    'web'
]

export default {

    isSpecificProvider: function (provider) {
        return specificProviders.includes(provider ? provider.toLowerCase() : '')
    }

}
